import Axios from "axios";
import PtsAlert from "../component/givBee/ptsAlert/PtsAlert";
import headerAction from "../redux/header/headerAction";
import staticDataAction from "../redux/staticData/staticDataAction";
import store from "../redux/store";
import ApplicationStateAction from "../redux/applicationState/ApplicationStateAction";
export const serverURL = "/givBeeApi";

const showLoader = () =>
  document.getElementById("iAmUniqueModalAT")
    ? (document.getElementById("iAmUniqueModalAT").style.display = "block")
    : "";
const hideLoader = () =>
  document.getElementById("iAmUniqueModalAT")
    ? (document.getElementById("iAmUniqueModalAT").style.display = "none")
    : "";
export const callPostServiceForPDFData = (url, data) => {
  url = serverURL + url;
  hideLoader();
  showLoader();
  return new Promise(function (accept, reject) {
    Axios.post(url, data).then((response) => {
      hideLoader();
      const responseData = response.data;
      if (responseData && responseData.length > 0) {
        accept(responseData);
      } else {
        let errorMessage = "No Data From Server";
        PtsAlert.error("No Data Received from Server");
        reject(errorMessage);
      }
    });
  });
  hideLoader();
};
export const callPostServiceForPDFReportData = (url, data) => {
  url = serverURL + url;
  hideLoader();
  showLoader();
  return new Promise(function (accept, reject) {
    Axios.post(url, data).then((response) => {
      hideLoader();
      const responseData = response.data;
      if (responseData) {
        accept(responseData);
      } else {
        let errorMessage = "No Data From Server";
        PtsAlert.error("No Data Received from Server");
        reject(errorMessage);
      }
    });
  });
  hideLoader();
};
export const callPostFileDownload = (url, data) => {
  url = serverURL + url;
  hideLoader();
  showLoader();
  return new Promise(function (accept, reject) {
    Axios.post(url, data)
      .then((response) => {
        hideLoader();
        accept(response);
      })
      .catch((error) => {
        hideLoader();
        if (error.name !== null && error.name === "TimeoutError") {
          reject("Can't reach to server,please try again later.");
        } else if (error.status) {
          let errorMessage = "Unknown Error occurred";
          switch (error.status) {
            /*
                  Unauthorized
                   */
            case 401:
              errorMessage = "Backend services not available.Please try in some time.";
              break;
            /*
                  Forbidden
                   */
            case 403:
              errorMessage =
                "You are not authorized to perform this operation or the resource is unavailable for some reason";
              break;
            /*
                  internal server error
                   */
            case 500:
              errorMessage =
                "Internal Server Error occurred , please try again later";
              break;
            /*
                  Request Timeout
                  */
            case 408:
              /*
                    gatewat timeout
                     */
              errorMessage =
                "Internal Server Error occurred , please try again later";
              break;
            case 504:
              /*
                     Network connect timeout error
                     */
              errorMessage =
                "Internal Server Error occurred , please try again later";
              break;
            case 599:
              errorMessage = "Can't reach to server , please try again later.";
              break;
            /*
                   Service Unavailable
                   */
            case 503:
              errorMessage =
                "Service you are trying is currently unavailable , please try again later.";
              break;
            default:
              errorMessage = "Backend services not available.Please try in some time.";
              break;
          }
          reject(errorMessage);
        } else {
          reject(error);
        }
      });
  });
  hideLoader();
};
export const callPostFileUpload = (url, data) => {
  url = serverURL + url;
  hideLoader();
  showLoader();
  return new Promise(function (accept, reject) {
    Axios.post(url, data)
      .then((response) => {
        hideLoader();
        const responseData = response.data;
        if (responseData.status === "SUCCESS") {
          //PtsAlert.success(responseData.message);

          // responseData.errorCode='TID_1000';
          // checkRequests.CheckRequests(responseData);
          accept(responseData);
        } else {
          // console.log(
          // 	"Service Call Failed :" +
          // 	url +
          // 	" width data " +
          // 	JSON.stringify(data) +
          // 	" Response:" +
          // 	JSON.stringify(responseData)
          // );
          let errCode = responseData.errorCode;
          responseData.message =
            null === responseData.message
              ? "Null Response"
              : responseData.message;
          PtsAlert.error(responseData.message);
          if (errCode === "TID_1000") {
            try {
              localStorage.clear();
              store.clear();
            } catch (err) { }

            window.location = "/ApLogin";
            reject("");

            // checkRequests(responseData);
            /*
                  Navigate to Login Page
                */
            //this.navCtr.setRoot(LoginPage);
          } else {
            accept(responseData);
          }
        }
      })
      .catch((error) => {
        hideLoader();
        if (error.name !== null && error.name === "TimeoutError") {
          reject("Can't reach to server,please try again later.");
        } else if (error.status) {
          let errorMessage = "Unknown Error occurred";
          switch (error.status) {
            /*
                  Unauthorized
                   */
            case 401:
              errorMessage = "Backend services not available.Please try in some time.";
              break;
            /*
                  Forbidden
                   */
            case 403:
              errorMessage =
                "You are not authorized to perform this operation or the resource is unavailable for some reason";
              break;
            /*
                  internal server error
                   */
            case 500:
              errorMessage =
                "Internal Server Error occurred , please try again later";
              break;
            /*
                  Request Timeout
                  */
            case 408:
              /*
                    gatewat timeout
                     */
              errorMessage =
                "Internal Server Error occurred , please try again later";
              break;
            case 504:
              /*
                     Network connect timeout error
                     */
              errorMessage =
                "Internal Server Error occurred , please try again later";
              break;
            case 599:
              errorMessage = "Can't reach to server , please try again later.";
              break;
            /*
                   Service Unavailable
                   */
            case 503:
              errorMessage =
                "Service you are trying is currently unavailable , please try again later.";
              break;
            default:
              errorMessage = "Backend services not available.Please try in some time.";
              break;
          }
          reject(errorMessage);
        } else {
          reject(error);
        }
      });
  });
  hideLoader();
};

export const callPostService = (url, data) => {
  url = serverURL + url;
  // export callPostService(url, data){
  hideLoader();
  showLoader();
  return new Promise(function (accept, reject) {
    // if (!data.header || !data.header.sessionid) {
    //   PtsAlert.error("Login Session Invalid, Please login again ");
    //   window.location = "/login";
    //   reject("");
    // }
    Axios.post(url, data)
      .then((response) => {
        hideLoader();
        const responseData = response.data;
        if (responseData.status === "SUCCESS") {
          //PtsAlert.success(responseData.message);
          // responseData.errorCode='TID_1000';
          // checkRequests.CheckRequests(responseData);
          accept(responseData);
        } else {
          let errCode = responseData.errorCode;
          responseData.message =
            null === responseData.message
              ? "Null Response"
              : responseData.message;
          PtsAlert.error(responseData.message);
          if (errCode === "AP_SESSIONEXP" || errCode === "SESSIONEXP") {
            try {
              localStorage.clear();
              store.clear();
            } catch (err) { }
            window.location = "/ApLogin";
          } else {
            accept(responseData);
          }
        }
      })
      .catch((error) => {
        hideLoader();
        if (error.name !== null && error.name === "TimeoutError") {
          PtsAlert.error("Can't reach to server,please try again later.");
          // reject("Can't reach to server,please try again later.");
        } else if (error.status) {
          let errorMessage =
            error.message && error.message
              ? error.message
              : "Unknown Error occurred";

          switch (error.status) {
            /*
                  Unauthorized
                   */
            case 401:
              errorMessage = "Backend services not available.Please try in some time.";
              break;
            /*
                  Forbidden
                   */
            case 403:
              errorMessage =
                "You are not authorized to perform this operation or the resource is unavailable for some reason";
              break;
            /*
                  internal server error
                   */
            case 500:
              errorMessage =
                "Internal Server Error occurred , please try again later";
              break;
            /*
                  Request Timeout
                  */
            case 408:
              /*
                    gatewat timeout
                     */
              errorMessage =
                "Internal Server Error occurred , please try again later";
              break;
            case 504:
              /*
                     Network connect timeout error
                     */
              errorMessage =
                "Internal Server Error occurred , please try again later";
              break;
            case 599:
              errorMessage = "Can't reach to server , please try again later.";
              break;
            /*
                   Service Unavailable
                   */
            case 503:
              errorMessage =
                "Service you are trying is currently unavailable , please try again later.";
              break;
            default:
              errorMessage = "Backend services not available.Please try in some time.";
              break;
          }
          PtsAlert.error(errorMessage);
          reject(errorMessage);
        } else {
          // let errorMessage = error.message
          //   ? error.message
          //   : "Unknown Error occurred";
          PtsAlert.error("Backend Api not available. Please try again later");
          reject("Backend Api not available. Please try again later");
        }
      });
  });
  hideLoader();
};

export const clearStorage = () => {
  store.dispatch(headerAction.setHeader({}));
  store.dispatch(staticDataAction.setStaticData({}));
  store.dispatch(ApplicationStateAction.setApplicationState({}));
  localStorage.clear();
};

export const callPostServiceWithoutHeader = (url, data) => {
  url = serverURL + url;
  // export callPostService(url, data){
  return new Promise(function (accept, reject) {
    Axios.post(url, data)
      .then((response) => {
        const responseData = response.data;
        if (responseData.status === "SUCCESS") {
          //PtsAlert.success(responseData.message);

          // responseData.errorCode='TID_1000';
          // checkRequests.CheckRequests(responseData);
          accept(responseData);
        } else {
          let errCode = responseData.errorCode;
          responseData.message =
            null === responseData.message
              ? "Null Response"
              : responseData.message;
          PtsAlert.error(responseData.message);
          if (errCode === "TID_1000") {
            try {
              localStorage.clear();
              store.clear();
            } catch (err) { }

            window.location = "/ApLogin";
            reject("");

            // checkRequests(responseData);
            /*
                  Navigate to Login Page
                */
            //this.navCtr.setRoot(LoginPage);
          } else {
            accept(responseData);
          }
        }
      })
      .catch((error) => {
        if (error.name !== null && error.name === "TimeoutError") {
          reject("Can't reach to server,please try again later.");
        } else if (error.status) {
          let errorMessage = "Unknown Error occurred";
          switch (error.status) {
            /*
                  Unauthorized
                   */
            case 401:
              errorMessage = "Backend services not available.Please try in some time.";
              break;
            /*
                  Forbidden
                   */
            case 403:
              errorMessage =
                "You are not authorized to perform this operation or the resource is unavailable for some reason";
              break;
            /*
                  internal server error
                   */
            case 500:
              errorMessage =
                "Internal Server Error occurred , please try again later";
              break;
            /*
                  Request Timeout
                  */
            case 408:
              /*
                    gatewat timeout
                     */
              errorMessage =
                "Internal Server Error occurred , please try again later";
              break;
            case 504:
              /*
                     Network connect timeout error
                     */
              errorMessage =
                "Internal Server Error occurred , please try again later";
              break;
            case 599:
              errorMessage = "Can't reach to server , please try again later.";
              break;
            /*
                   Service Unavailable
                   */
            case 503:
              errorMessage =
                "Service you are trying is currently unavailable , please try again later.";
              break;
            default:
              errorMessage = "Backend services not available.Please try in some time.";
              break;
          }
          reject(errorMessage);
        } else {
          reject(error);
        }
      });
  });
};
//}
export default {
  callPostFileDownload,
  callPostFileUpload,
  callPostService,
  callPostServiceForPDFData,
  callPostServiceForPDFReportData,
  callPostServiceWithoutHeader,
  clearStorage,
  hideLoader,
  showLoader,
};
